








import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import CommDay from '@/pages/integration/UpdateAppSettings/CommDay.vue'
import { CommHoursInterface } from '@/pages/integration/UpdateAppSettings/types/comm-hours'

const dayKeys = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

@Component({
    components: {
        CommDay
    }
})
export default class CommHours extends Vue {
  dayKeys = dayKeys;
  @Prop() value!: CommHoursInterface;
  @Prop({ default: true }) disabled!: boolean;

  @Emit('input')
  handleInput(): CommHoursInterface {
      return this.value
  }
}
